<app-page-header title="Promotion Types" description="Maintain the list of promotion types available when creating a promotion."></app-page-header>
<div class="grid">
<dx-data-grid #promotionTypeGrid
  [dataSource]="dataSource"
  [remoteOperations]="false"
  [allowColumnReordering]="false"
  [rowAlternationEnabled]="true"
  [height]="'100%'"
>
<dxo-editing
    mode="batch"
    [allowAdding]="true"
    [allowUpdating]="true"
    [allowDeleting]="true"
  >
  </dxo-editing>
  <dxo-scrolling mode="virtual"></dxo-scrolling>
  <dxo-search-panel [visible]="true"></dxo-search-panel>
  <dxi-column dataField="name" dataType="string" caption="Name">
    <dxi-validation-rule type="required" message="promotion-type name is required"></dxi-validation-rule>   
  </dxi-column>
</dx-data-grid>
</div>